import { DiscordChannel } from "@/lib/api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Hash, Folder } from "lucide-react";

interface Props {
  channels: DiscordChannel[];
  value: string;
  onChange: (id: string) => void;
  placeholder?: string;
  /** 0 = text, 4 = category */
  typeFilter?: number;
}

export function ChannelPicker({
  channels,
  value,
  onChange,
  placeholder = "Select channel",
  typeFilter = 0,
}: Props) {
  const filtered = channels.filter((c) => c.type === typeFilter);
  const Icon = typeFilter === 4 ? Folder : Hash;
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        <SelectItem value="__none__">(none)</SelectItem>
        {filtered.map((c) => (
          <SelectItem key={c.id} value={c.id}>
            <span className="inline-flex items-center gap-1.5">
              <Icon className="h-3 w-3" />
              {c.name}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
